var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalkaCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#004529"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5175 4.64943C10.5994 4.73146 10.6455 4.84266 10.6455 4.9586C10.6455 5.07454 10.5994 5.18573 10.5175 5.26777L6.43418 9.3511C6.35214 9.43303 6.24095 9.47905 6.12501 9.47905C6.00907 9.47905 5.89787 9.43303 5.81584 9.3511L3.48251 7.01777C3.43952 6.97771 3.40505 6.92941 3.38114 6.87575C3.35722 6.82208 3.34437 6.76415 3.34333 6.7054C3.34229 6.64666 3.3531 6.58831 3.3751 6.53383C3.39711 6.47936 3.42986 6.42987 3.4714 6.38833C3.51295 6.34678 3.56243 6.31403 3.61691 6.29203C3.67139 6.27002 3.72974 6.25922 3.78848 6.26025C3.84722 6.26129 3.90516 6.27415 3.95882 6.29806C4.01249 6.32197 4.06079 6.35645 4.10084 6.39943L6.12501 8.4236L9.89917 4.64943C9.98121 4.5675 10.0924 4.52148 10.2083 4.52148C10.3243 4.52148 10.4355 4.5675 10.5175 4.64943Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalkaCircle);
export default __webpack_public_path__ + "static/media/galkaCircle.93b0a5fecfff878b383fbb312d909a0f.svg";
export { ForwardRef as ReactComponent };